import ReactDOM from "react-dom";
import App from "./App";
import { initAmplitude } from "./analytics";
import { appEnv } from "./appEnv";

initAmplitude(appEnv.REACT_APP_AMPLITUDE_API_KEY);

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
